<template>
    <div class="modal fade custom-right-modal" id="quotationHistoryModal" ref="quotationHistoryModal">
        <div class="modal-dialog" style="max-width: 90% !important;">
            <div class="modal-content">

                <!-- Modal Header -->
                <div class="modal-header">
                    <h4 class="modal-title">History</h4>
                    <button type="button" class="close" data-dismiss="modal"><i class="ri-close-line"></i></button>
                </div>

                <!-- Modal body -->
                <div class="modal-body">
                    <div class="history-d">
                        <template v-for="(item, index) in history.quote_history">
                            <div class="task-bg" v-if="item.reason">
                                <div class="small-heading">#{{quotation.quote_number}} moved to {{item.status}}</div>
                                <div><h4>Reason {{item.reason}}</h4></div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="light-clr">Updated By</div>
                                        <p class="number">{{item.user_name}}</p>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="light-clr">Updated Time</div>
                                        <p class="number">{{item.created_at}}</p>
                                    </div>
                                </div>
                            </div>

                            <div class="task-bg" v-if="item.old_added_by">
                                <div class="small-heading">#{{quotation.quote_number}} updated added by from {{item.old_added_by}} to {{item.new_added_by}}</div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="light-clr">Updated By</div>
                                        <p class="number">{{item.user_name}}</p>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="light-clr">Updated Time</div>
                                        <p class="number">{{item.created_at}}</p>
                                    </div>
                                </div>
                            </div>

                            <div class="task-bg" v-else>
                                <div class="small-heading">#{{quotation.quote_number}} moved to {{item.status}}</div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="light-clr">Updated By</div>
                                        <p class="number">{{item.user_name}}</p>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="light-clr">Updated Time</div>
                                        <p class="number">{{item.created_at}}</p>
                                    </div>
                                </div>
                            </div>

                        </template>
                    </div>

                </div>

                <!-- Modal footer -->
                <div class="modal-footer">

                </div>

            </div>
        </div>
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";

export default {
    name: "QuotationHistoryModal",
    props: ['quotation',],
    created() {
    },
    mounted() {
        $(this.$refs.quotationHistoryModal).on('show.bs.modal', () => {
            this.getHistory();
        });
    },
    data() {
        return {
            history: {
                quote_history: []
            }
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
        ]),
        getHistory() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            let apiUrl = window.route('quotations.getHistory');

            return axios.post(apiUrl, {quote_id: this.quotation.id}, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.data) {
                        this.history = data.data;
                    } else {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },

    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'loading',
        ])
    }
}
</script>

<style scoped>

</style>
